"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vindi_gateway_1 = __importDefault(require("./gateways/vindi.gateway"));
const PaymentToken_model_1 = __importDefault(require("./models/PaymentToken.model"));
const isRunningOnBrowser = () => typeof window !== 'undefined' && typeof window.document !== 'undefined';
/**
 * Class used to encapsulate all functionalities of Sanar's Payments SDK
 *
 * ```typescript
 * const payments = new Payments('prod');
 * ```
 */
class Payments {
    /**
     * @param environment runtime environment
     */
    constructor(environment, service = 'vindi_sanar') {
        /**
         * Generates a secret payment token that can be used to create/update a subscription
         * @returns Secret payment token that can be used to create/update a subscription
         */
        this.getCardPaymentToken = async (cardInformation) => {
            if (!isRunningOnBrowser() && this.environment !== 'preprod')
                throw new Error('For security reasons, this method can only be executed in a browser.');
            const paymentToken = new PaymentToken_model_1.default({
                vindi: await this.vindiGateway.getGatewayToken(cardInformation),
            }, cardInformation);
            return paymentToken.encode();
        };
        this.vindiGateway = new vindi_gateway_1.default(environment, service);
        this.environment = environment;
    }
}
exports.default = Payments;
